module.exports = __webpack_public_path__ + "img/tabbed-search-filter-honda.53ec4052.png";